module.exports = __webpack_public_path__ + "europa-100-portrait_window.jpg?bcd080856679bf19073b6507fa953438";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-100-portrait_window.jpg
// module id = 259
// module chunks = 0